import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';

const schema = createApiResponseSchema();

export async function updateLeaderboardScoreApi(
  userId: string,
  score: number,
): Promise<IValidatedResponse<IAPI>> {
  return putRequest<IAPI>({
    path: `/sys/leaderboard/${userId}/score`,
    body: { score },
    schema,
  });
}
